<template>
  <div>
    <column-chart :data="chartData2" :stacked="true"></column-chart>
  </div>
</template>

<script>
import { CONSTANTS } from "@/common/constants.js";
import { mapGetters } from "vuex";
import { STORE_CONSTANTS } from "@/common/store.constants.js";

export default {
  name: "BottomBarChart",
  data: function () {
    return {
		STORE_CONSTANTS,
      	chartData2: null,
      	dataParsed: null,
    };
  },
    computed: {
	...mapGetters("allTasks", [
        "getTasks"
    ]),
  },
	watch: {
    // whenever question changes, this function will run
    dataParsed: function (newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
		this.getChartData();
      }
    },	
  },
  beforeMount () {
	this.dataParsed = (this.getTasks) ? this.getTasks : [];
  },
  mounted() {
	const me = this;  // scoped this as in the component
    me.unsubscribe = me.$store.subscribe((mutation, state) => {
      if(mutation.type === me.STORE_CONSTANTS.ALL_TASKS.MUTATIONS.WITH_NAMESPACE.SET_TASKS) {
        me.dataParsed = state.allTasks.tasks;
      }
    });
  },
  methods: {
	getChartData() {
		// simplifiedArray simplifies the data to only have Statuses and dateEnds
		let simplifiedArray = [];
		for (let piece of this.dataParsed) {
			// console.log("piece.properties.Status :", piece.properties.Status)
			if (piece.taskStatus) {
				let sampleObject = {
					Status: piece.taskStatus,
					dateEnd: piece.dateEnd.substring(0, 10)
				};
				simplifiedArray.push(sampleObject);
			}
    	}

		// console.log("cht6: simplifiedArray for bottom table: ", simplifiedArray)
		// // totalObj oragnizes the dats into an object with Status Names as keys,
		// // that contains an object with dates as keys and count numbers as values
		let totalObj = {};
		for (let StatusAndDateObj of simplifiedArray) {
			if (StatusAndDateObj.Status in totalObj) {
				totalObj[StatusAndDateObj.Status].push(StatusAndDateObj.dateEnd);
        		totalObj[StatusAndDateObj.Status] = totalObj[StatusAndDateObj.Status];
      		} else {
				let array = [];
				array.push(StatusAndDateObj.dateEnd);
        		totalObj[StatusAndDateObj.Status] = array;
      		}
		}
		// console.log("cht9: totalObj: ", totalObj)
		// // function for counting up dates
		function DateCounted (array1) {
			let myCHTObj1 = {}
			for (var sidePiece1 of array1) {
				if (sidePiece1 in myCHTObj1) {
					myCHTObj1[sidePiece1]++;
				} else {
					myCHTObj1[sidePiece1] = 1;
				}
			}
			return myCHTObj1;
		}
		// converts totalObj to have more objects
		for (let subset in totalObj)	{
			totalObj[subset] = DateCounted(totalObj[subset]);
		}
		console.log("cht12: final totalObj", totalObj);
		// // Example of correct formate for data
		// this.chartData2  = [
		// 	{name: 'SUSPECT', data: {'2017-01-01': 3}, color: 'red'},
		// 	{name: 'NO_DATA', data: {'2017-01-01': 5, '2017-01-02': 3}, color: 'blue'},
		// 	{name: 'UNDER_REVIEW', data: {'2017-01-01': 5, '2017-01-02': 3, color: 'turquoise'}},
		// 	{name: 'FALSIFIED', data: {'2017-01-01': 5, '2017-01-02': 3}, color: 'rgb(211, 211, 211)'},
		// 	{name: 'COMPLETED', data: {'2017-01-01': 5, '2017-01-02': 3}, color: 'rgb(0, 137, 247)'},
		// 	{name: 'VALID', data: {'2017-01-01': 0, '2017-01-02': 0}, color: 'green'}
		// ];
		var correctFormatDataArray = [];
		for (let small in totalObj) {
			let individualObj = {};
			individualObj.name = small;
			individualObj.data = totalObj[small];
			correctFormatDataArray.push(individualObj);
		}
		console.log("cht13: correctFormatDataArray: ", JSON.stringify(correctFormatDataArray));

		// sorting the data parts to be in order
		function sortObject (obj) {
			return Object.keys(obj).sort().reduce(function (result, key) {
				result[key] = obj[key];
				return result;
			}, {});
		}
		for (let piece of correctFormatDataArray) {
			piece.data = sortObject(piece.data)
			switch (piece.name) {
				case 'SUSPECT':
					piece.color = 'red'
					break;
				case 'NO_DATA':
					piece.color = 'purple'
					break;
				case 'UNDER_REVIEW':
					piece.color = 'turquoise'
					break;
				case 'FALSIFIED':
					piece.color = 'rgb(211, 211, 211)'
					break;
				case 'COMPLETED':
					piece.color = 'rgb(0, 137, 247)'
					break;
				case 'VALID':
					piece.color = 'green'
					break;
				case 'UPDATED':
					piece.color = 'black'
					break;
				case 'UNKNOWN':
					piece.color = 'yellow'
					break;
					default:
			}
		}
		this.chartData2 = correctFormatDataArray;
	}
  }
};
</script>

<style>
</style>
